module.exports = __webpack_public_path__ + "static/awards____2x-344346105838294303b52e0a1db1b924.png";